import React from 'react';
import Marquee from 'react-fast-marquee';
import Style from './style.module.scss';

export default function Ticker() {
  return (
    <div>
      <Marquee autoFill speed={100} className={Style.marquee}>
        <div>
          <img src={'./assets/img/companies-marquee.svg'} alt="nGaming corporates" />
        </div>
      </Marquee>
    </div>
  );
}
